import type { Option } from '@unifyapps/defs/blocks/ButtonGroup/types';
import { useGetCanAccess } from '@unifyapps/carbon/no-code/access-control/hooks/useGetCanAccess';

export const usePermissibleButtons = ({ buttons = [] }: { buttons?: Option[] }): Option[] => {
  const canAccess = useGetCanAccess();

  return buttons.filter((button) => canAccess(button.permissions));
};
